import cn from "classnames";
import { ChevronDown as ChevronDownIcon } from "@rshbintech.dboul/icons";
import { Text } from "../../../../text";
import { RightIconProps } from "./types";
import styles from "./styles.module.scss";

export const RightIcon = ({
  disabled,
  dataTestId,
  expanded,
  additionalLabel,
}: RightIconProps) => (
  <>
    {additionalLabel && (
      <Text
        dataTestId={`${dataTestId}-additional-option-label`}
        className={cn(styles["additional-option-label"], {
          [styles.disabled]: disabled,
        })}
      >
        {additionalLabel}
      </Text>
    )}

    <ChevronDownIcon
      className={cn(styles["chevron-icon"], {
        [styles.expanded]: expanded,
        [styles.disabled]: disabled,
      })}
      dataTestId={`${dataTestId}-chevron-icon`}
    />
  </>
);
